module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/connect-mobile-1d5302f189186d7073d2ad2f5c929ea9.png";